import React from 'react';
import {Container, Row, Col, CardImg} from 'reactstrap';

import './cloudInstructor.css';

const CloudInstructor = () => {
    return(
        <div className='pb-5 mb-5'>
            <Container className='justify-content-center'>
                <Row className='justify-content-center'>
                    <Col xs={{ size: 12 }} md={{ size: 10}}>
                        <div className='instructor-card position-relative'>
                            
                            <h1 className='fw-500 text-center text-md-left'>Meet Your Instructor</h1>
                            <Row className='pt-3'>
                                <Col xs={{ size: 12 }} sm={{ size: 3}}>
                                    <Row>
                                        <Col xs={{ size: 12}}>
                                            <CardImg
                                                src='img/chandra/Chandra.png'
                                            />
                                        </Col>
                                        <Col xs={{ size: 12}} className='pt-2'>
                                            <h3 className='fw-400'>Chandra Lingam</h3>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 9 }}>
                                    <p className='fw-300'>
                                    Chandra is an expert on Amazon Web Services, mission critical systems and machine learning.  He has a rich background in systems development in both traditional IT data center and Cloud based infrastructure. For those new to AWS, he is uniquely positioned to guide you to become an expert in AWS Cloud Platform. 
                                    <br/>
                                    <br/>
                                    Prior to becoming a full-time course developer and instructor, he spent 15 years at Intel, developing and managing systems that handled hundreds of terabytes of worldwide factory data.  
                                    <br/>
                                    <br/>
                                    He has a Master's degree in Computer Science from Arizona State University, Tempe and Bachelor's degree in Computer Science from Thiagarajar College of Engineering, Madurai
                                    </p>
                                </Col>
                            </Row>
                            <CardImg
                                src='img/cloud-icon.svg'
                                className='ci-cloud-img'
                            />
                        </div>
                    </Col>
                </Row>
                
            </Container>
        </div>
    );
}

export default CloudInstructor;